function FirstChapter() {
  return (
    <>
      <article>
        <h1>INTERNET Z DÁLKY</h1>
        <p>
          „Internet z dálky“ je první z čtyř témat, která aplikace pokrývá.
          Hlavním cílem této kapitoly je vytvořit u žáka základní pochopení
          toho, co je internet. Během aktivit by si žák měl uvědomit, že
          internet není abstraktní koncept, ale obrovská síť vzájemně
          propojených fyzických zařízení. Aktivity v této kapitole umožňují
          žákovi seznámit se s jednotlivými zařízeními a pochopit, jak jsou
          propojeny a jak spolu vzájemně interagují. Proto doporučujeme, abyste
          před zahájením aktivit vedli krátkou diskusi o internetu a jeho
          fungování. Tato debata pomůže žákům lépe se připravit na nové téma a
          učitelům poskytne lepší představu o tom, jak žáci chápou dané téma.
          Také může předem odhalit jakékoliv nesprávné představy, které žáci
          mohou mít, a umožní učitelům se zaměřit na jejich korekci během
          aktivit. Pro diskusi můžete například použít pracovní listy nebo pro
          úvodní seznámení s tématem můžete využít pořad Datová Lhota. Oba dva
          materiály jsou k dispozici na stránkách{" "}
          <a target="_blank" href="https://internet4kids.mff.cuni.cz/projekty/">
            internet4kids
          </a>
          .
        </p>
      </article>
      <article>
        <h1>Co je server</h1>
        <h2>Typ aktivity</h2>
        <p>Úkol</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>
            Žák by měl v rámci aktivity pochopit, že data, která hledá na
            internetu, jsou uložena na zařízeních, kterým říkáme servery.
          </li>
          <li>
            Mělo by zde dojít k propojení se známým pojmem upload, nahrávání dat
            na server.
          </li>
        </ul>
        <h2>Zadání</h2>
        <p>
          Žák má za úkol nahrát (uploadovat) tři soubory (webovku, obrázek,
          video) do správného serveru. Nahrání provede přetažením obrázku
          souboru na obrázek serveru, na který chce soubor nahrát. V případě, že
          se soubor dotýká správného serveru, objeví se okno s vysvětlujícím
          textem.
        </p>
        <h2>Řešení</h2>
        <p>
          Řešením úlohy je přetáhnout webovku na server webhostingu, obrázek na
          server Instagramu a video na server YouTube.
        </p>

        <div class="image server"></div>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            Je možné s žáky rozvést debatu o tom, zda by bylo možné i jiné
            řešení úlohy. Například přes Messenger si můžeme posílat kromě
            textových zpráv také fotky a videa, proto i na Messenger serveru
            bude uloženo spousta fotek a videí. V úkolu jsme však cílili na
            primární účel platforem (Instagram jako platforma na sdílení fotek a
            YouTube jako platforma pro přehrávání videí).
          </p>
        </div>
      </article>
      <article>
        <h1>Co je klient a proč potřebuje komunikovat</h1>
        <h2>Typ aktivity</h2>
        <p>Vizualizace</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>Žák se v rámci aktivity seznámí s pojmem klient.</li>
          <li>
            Následuje vysvětlení toho, proč je nutná komunikace se serverem,
            čímž dojde k propojení s již známým pojmem server.
          </li>
        </ul>
        <h2>Popis vizualizace</h2>
        <p>
          Vizualizace znázorňuje celý proces komunikace mezi klientem a
          serverem, který byl popsán v informačním okně před zahájením
          vizualizace. Vizualizace začíná myšlenkou klienta, který by si chtěl
          zobrazit webovou stránku. Následuje poslání požadavku na server s
          formulací požadavku v lidské řeči. Server zobrazí potvrzení a doručení
          požadavku a pošle zpátky webovou stránku. Vizualizace končí
          spokojeností klienta, kterému byla úspěšně doručena požadovaná webová
          stránka ze serveru.
        </p>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            V aplikaci je téma rozděleno do dvou aktivit. První (Klient)
            představí žákovi pojem klient. Druhá (Komunikace klient-server)
            propojuje pojmy klient a server a vysvětluje, proč musí tyto prvky
            sítě vzájemně komunikovat.
          </p>
          <p>
            V reálné komunikaci samozřejmě nejsou požadavky formulovány jako
            srozumitelné věty. Na tento fakt je dobré žáky upozornit. Pro lepší
            demonstraci lze realizovat doplňkové aktivity. Můžete třeba s žáky
            vymyslet, proč je požadavek „Pošli mi webovku“ nedostatečný (server
            by například mohl poslat úplně jinou webovku, než jsme měli na
            mysli).
          </p>
          <p>
            Žáci mají pojem klient většinou spojený se zákazníkem v obchodě či
            znají klienta u doktora. Je dobré explicitně upozornit na odlišný
            význam, aby v budoucnu nedocházelo k záměně.
          </p>
        </div>
      </article>
      <article>
        <h1>Putování informací</h1>
        <h2>Typ aktivity</h2>
        <p>Vizualizace</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>
            Žák by měl v rámci aktivity získat představu o tom, kudy putují
            informace, než se dostanou od odesílatele k příjemci.
          </li>
        </ul>
        <h2>Popis vizualizace</h2>
        <p>
          Vizualizace znázorňuje v jedné mapě všechny prvky, které byly doteď
          představeny. Žák může mapu přibližovat tlačítky plus a mínus
          umístěných v pravém dolním rohu, kolečkem myši nebo dvojklikem. V mapě
          se může pohybovat všemi směry pomocí stisknutí myši a přetažení.
          Vizualizace tedy zachovává typické chování, na které jsou žáci zvyklí
          např. z Google Maps.
        </p>
        <div class="note">
          {" "}
          <h2>Poznámky</h2>
          <p>
            Před zahájením této aktivity je doporučeno rozvést diskusi s žáky.
            Nejdříve pusťte žákům vizualizaci v aktivitě Komunikace
            klient-server. Poté rozveďte debatu o tom, kudy se dostal požadavek
            klienta na server.
          </p>
          <p>
            Téma bylo v aplikaci rozděleno do tří částí. První (Putování
            informací) představí žákovi povrchně pomocí vhodné analogie pojmy
            cesta pro informace a chytrá křižovatka a v rámci vizualizace ukáže
            souvislost z předchozími pojmy server a klient. Druhá (Cesta) a
            třetí (Chytrá křižovatka) pak detailněji rozebere dva nové pojmy.
          </p>
          <p>
            Žákům je potřeba neustále připomínat, že se nejedná o reálnou
            topologii sítě. Pro věrnější ukázku je možné využít jiné aplikace,
            které se zaměřují na věrohodné znázornění rozmístění prvků sítě. Na
            naší mapě jde ovšem učinit zásadní klíčové pozorování, tedy že
            internet je skutečně decentralizovaná síť navzájem propojených
            zařízení. Také lze mapu například použít pro hledání cest mezi dvěma
            zařízeními.
          </p>
        </div>
      </article>
    </>
  );
}

export default FirstChapter;
